import { restClient } from '@/Core'

/** У кошик (разом із піддеревом): `POST /services/disk/nodes/trash`. */
export const TrashDiskNodesTask = async (nodes: string[]): Promise<void> => {
    await restClient.post('/services/disk/nodes/trash', { json: { nodes } })
}
